/** Shown by default (dev/QA). Set REACT_APP_SUPERSET_DASHBOARD_ENABLED=false in prod to hide. */
export const SUPERSET_DASHBOARD_ENABLED =
  process.env.REACT_APP_SUPERSET_DASHBOARD_ENABLED !== 'false';

export const SUPERSET_DOMAIN =
  process.env.REACT_APP_SUPERSET_DOMAIN || 'https://reports.mybasepay.com';

/** Deprecated: the backend no longer uses slug-based Superset routes. */
export const SUPERSET_DASHBOARD_SLUG =
  process.env.REACT_APP_SUPERSET_DASHBOARD_SLUG || 'dev-my-workers';

export const USER_FACING_ERROR_MESSAGE =
  'Unable to load reports. Please try again or contact support.';

export const SUPERSET_SDK_URL = 'https://unpkg.com/@superset-ui/embedded-sdk@0.3.0';

export const SUPERSET_DASHBOARD_UI_CONFIG = {
  hideTitle: true,
  hideTab: true,
  hideChartControls: true,
  filters: {
    visible: false,
  },
} as const;
